<al-budget-group-base [attr.data-cy]="project?.projectCode"
                      [node]="node"
                      [translationKey]="translationKey"
                      [icon]="faBriefCase"
                      [refreshSubject]="refreshSubject"
                      [allowExpandAll]="true" />

<al-cell-drop-zone [node]="node"
                   [droppable]="isDroppable"
                   (dragOverDelay)="expand()" />
